<template>
  <v-chip
    small
    outlined
    :href="hubspotTicketUrl"
    :target="hubspotTicketUrl ? '_blank' : undefined"
    rel="noopener"
  >
    {{ $t('supportRequests.card.ticket', { id: ticketId }) }}
  </v-chip>
</template>

<script>
export default {
  name: 'SupportRequestTicketChip',
  props: {
    ticketId: { type: String, required: true },
  },
  computed: {
    // Los tickets sembrados a mano para demo llevan el prefijo "DEMO-" (KB-900)
    // para que la ejecución real nunca responda/cierre el ticket real; acá se
    // saca ese prefijo para armar el link al ticket real de HubSpot.
    hubspotTicketUrl() {
      const portalId = process.env.VUE_APP_HUBSPOT_PORTAL_ID;
      if (!portalId) return undefined;
      const realTicketId = this.ticketId.replace(/^DEMO-/, '');
      return `https://app.hubspot.com/contacts/${portalId}/record/0-5/${realTicketId}`;
    },
  },
};
</script>
